import * as React from "react";
const SvgArrowIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 1L2 8M2 8L9 15M2 8H16", stroke: "currentColor", strokeWidth: 2 }));
export default SvgArrowIcon;
